// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastPlayer-cls1_Lbr","cls2":"PodcastPlayer-cls2_znX PodcastPlayer-cls1_Lbr"};